import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './TransportGoodView.html?raw';
import { TiEntities, TiInterfaces } from "./TiTypes";

class TiTransportGoodView extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private loading: HTMLElement;
    private loadingAddress: HTMLElement;
    private unloading: HTMLElement;
    private unloadingAddress: HTMLElement;
    private loadingDate: HTMLElement;
    private unloadingDate: HTMLElement;
    private customerInfo: HTMLElement;
    private sectionsContainer: HTMLElement;
    private sectionDispatcher: HTMLElement;
    private dispatcher: HTMLElement;
    private sectionCustomer: HTMLElement;
    private sectionLoading: HTMLElement;
    private sectionUnloading: HTMLElement;
    private sectionLoadingDate: HTMLElement;
    private sectionUnloadingDate: HTMLElement;
    private orderNo: HTMLElement;
    //private sectionOrderNo: HTMLElement;
    private goodCategory: HTMLElement;
    private goodLDM: HTMLElement;
    //private sectionGoodCategory: HTMLElement;
    private sectionWarnings: HTMLElement;
    private warningsContainer: HTMLElement;
    private sectionStatus: HTMLElement;
    private status: HTMLElement;
    private txtHeading: HTMLElement;


    private data: TiEntities.TransportGoodEntity;

    private _htmlBreaks(value: string): string {
        if (!value) return "";

        return this.stringReplaceAll(value, "\n", "<br>");
    }
    private _nullSafeString(value: string): string {
        if (!value) return "";

        return value;
    }
    setData(data: TiEntities.TransportGoodEntity, compareData?: TiInterfaces.BookingFormData) {
        this.data = data;

        this.txtHeading.innerHTML = data.order_number;
        this.hideNode(this.txtHeading, !data.order_number);


        this.UiModder.domAttr.set(this.customerInfo, 
            "innerHTML", 
            this._htmlBreaks(data.ref_customer?.displayname));
        this.hideNode(this.customerInfo.parentElement, !this.data.ref_customer );

        this.UiModder.domAttr.set(this.loading, 
            "innerHTML",
            this._htmlBreaks(data.c_address_loading));

        this.UiModder.domAttr.set(this.loadingAddress, 
            "innerHTML",
            this._htmlBreaks(data.tmp_displayname_location_loading));

        this.hideNode(this.loading.parentElement, !this.data.c_address_loading);

        this.UiModder.domAttr.set(this.unloading, 
            "innerHTML",
            this._htmlBreaks(data.c_address_unloading ));

        this.UiModder.domAttr.set(this.unloadingAddress, 
            "innerHTML",
            this._htmlBreaks(data.tmp_displayname_location_unloading));

        this.hideNode(this.unloading.parentElement,  !this.data.c_address_unloading);

        this.UiModder.domAttr.set(this.loadingDate,
            "innerHTML",
            this.data.loading_time_start ? this.dateToString(this.data.loading_time_start, "dd.MM.yyyy") : "--");
        //this.UiModder.domClass.toggle(this.loadingDate.parentElement, "w3-hide", !this.data.loading_time_start);

        this.UiModder.domAttr.set(this.unloadingDate, 
            "innerHTML",
            this.data.unloading_time_end ? this.dateToString(this.data.unloading_time_end, "dd.MM.yyyy") : "--");
        //this.UiModder.domClass.toggle(this.unloadingDate.parentElement, "w3-hide", !this.data.unloading_time_end);


        this.UiModder.domAttr.set(this.orderNo, 
            "innerHTML",
            this._nullSafeString(data?.order_number));
        //this.hideNode(this.sectionOrderNo, typeof (data.order_number) != "string");

        this.UiModder.domAttr.set(this.goodLDM,
            "innerHTML",
            this._nullSafeString(data?.LDM?.toFixed(2)));

        this.UiModder.domAttr.set(this.dispatcher, 
            "innerHTML",
            data?.ref_dispatcher ? data.ref_dispatcher.displayname : "-");

        this.hideNode(this.sectionDispatcher, !data.ref_dispatcher);

        let statusTxt = this.UiModder.domConstruct.create("lbl", {
            innerHTML: data.ref_status_good?.name,
            style: { "padding": "2px"}
        }, this.status, "only");
        if (this.data.ref_status_good?.coloration) {
            //this.UiModder.domClass.add(statusTxt, "infoBG");
            //this.UiModder.domStyle.set(statusTxt, "outlineColor", this.data.ref_status_good.coloration.TextColor.Hex);
            this.UiModder.domStyle.set(statusTxt, "color", this.data.ref_status_good.coloration.TextColor.Hex);
            this.UiModder.domStyle.set(statusTxt, "backgroundColor", this.data.ref_status_good.coloration.BackColor.Hex);
        }
        
        this.hideNode(this.sectionStatus, !data.ref_status_good);

        let goodTxt = this.UiModder.domConstruct.create("lbl", {
            innerHTML: data.ref_good_category?.displayname ? data.ref_good_category.displayname : "--",
            style: { "padding": "2px" }
        }, this.goodCategory, "only");
        if (this.data.ref_good_category?.coloration) {
            //this.UiModder.domClass.add(statusTxt, "infoBG");
            //this.UiModder.domStyle.set(statusTxt, "outlineColor", this.data.ref_status_good.coloration.TextColor.Hex);
            this.UiModder.domStyle.set(goodTxt, "color", this.data.ref_good_category.coloration.TextColor.Hex);
            this.UiModder.domStyle.set(goodTxt, "backgroundColor", this.data.ref_good_category.coloration.BackColor.Hex);
        }
        //this.hideNode(this.sectionGoodCategory, !data.ref_good_category);

        //if (data.warnings) {
        //    this.emit("warning");
        //    this.UiModder.domClass.toggle(this.sectionWarnings, "w3-hide", data.warnings.length <= 0);

        //    for (let warning of data.warnings) {
        //        this.UiModder.domConstruct.create("div", { "innerHTML": warning, "className": "warning" }, this.warningsContainer);
        //    }
        //}

        //this.loadWarnings(compareData);

    }

    private loadWarnings(compareData: TiInterfaces.BookingFormData) {
        if (this.data && compareData) {
            this.RequestManager.callfunction(
                "Webtool_API_TransportIntermodal__GetWarningsOfTransportGood",
                {
                    booking: compareData,
                    transportGoodID: this.data.ID
                },
                lang.hitch(this, this._onLoadWarnings),
                lang.hitch(this, this._onLoadWarningsError)
            );
        }
    }

    private _onLoadWarnings(response) {

    }

    private _onLoadWarningsError(error: more.requestErrorMessage) {

    }

    makeCompact(bCompact: boolean = true) {
        this.UiModder.domClass.toggle(this.sectionsContainer, "flex_row", bCompact !== false);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

    }

    destroy(): void {
        super.destroy.apply(this, arguments as any);
    }
    startup() {
        super.startup.apply(this, arguments as any);
    }

}

export default mdsWidget(TiTransportGoodView);